import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_clickoncedeploy {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ClickOnceDeployURLSelect
	//
	//-----------------------------------------------------------------------------------------------------
	ClickOnceDeployURLSelect() {
		var postResult$ = new Subject();
		var url = "PhotoID/ClickOnceDeployURLSelect";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
